/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonLocationFromJSON, InternalCommonLocationToJSON, } from './InternalCommonLocation';
import { InternalCommonUserConfigFromJSON, InternalCommonUserConfigToJSON, } from './InternalCommonUserConfig';
import { InternalCommonUserPhotoFromJSON, InternalCommonUserPhotoToJSON, } from './InternalCommonUserPhoto';
import { InternalCommonCustomAttributeFromJSON, InternalCommonCustomAttributeToJSON, } from './InternalCommonCustomAttribute';
import { InternalCommonStorageUploadFromJSON, InternalCommonStorageUploadToJSON, } from './InternalCommonStorageUpload';
import { CommonISO3166CountryCodeFromJSON, CommonISO3166CountryCodeToJSON, } from './CommonISO3166CountryCode';
import { InternalCommonPostalAddressFromJSON, InternalCommonPostalAddressToJSON, } from './InternalCommonPostalAddress';
import { InternalCommonUserSkillFromJSON, InternalCommonUserSkillToJSON, } from './InternalCommonUserSkill';
/**
 * @export
 */
export const InternalCommonUserPrimaryEmailChoiceEnum = {
    Email: 'email',
    Email2: 'email2',
    Email3: 'email3'
};
/**
 * @export
 */
export const InternalCommonUserGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
/**
 * @export
 */
export const InternalCommonUserPreferredPhoneNumberEnum = {
    MobilePerso: 'mobile_perso',
    MobilePro: 'mobile_pro',
    LandlinePro: 'landline_pro',
    LandlinePerso: 'landline_perso',
    None: 'none'
};
/**
 * @export
 */
export const InternalCommonUserPreferredPostalAddressEnum = {
    PostalPersonal: 'postal_personal',
    PostalWork: 'postal_work'
};
/**
 * @export
 */
export const InternalCommonUserHonoraryTitleEnum = {
    Dr: 'dr',
    Prof: 'prof',
    Mr: 'mr',
    Mrs: 'mrs',
    Ms: 'ms',
    Miss: 'miss',
    Sir: 'sir',
    Dame: 'dame',
    Lord: 'lord',
    Lady: 'lady',
    Hon: 'hon',
    Rev: 'rev',
    Fr: 'fr',
    Sr: 'sr',
    Br: 'br'
};
/**
 * Check if a given object implements the InternalCommonUser interface.
 */
export function instanceOfInternalCommonUser(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('subNetworkIds' in value) || value['subNetworkIds'] === undefined)
        return false;
    if (!('extendedUpdatedAt' in value) || value['extendedUpdatedAt'] === undefined)
        return false;
    if (!('photo' in value) || value['photo'] === undefined)
        return false;
    if (!('email2' in value) || value['email2'] === undefined)
        return false;
    if (!('email3' in value) || value['email3'] === undefined)
        return false;
    if (!('primaryEmailChoice' in value) || value['primaryEmailChoice'] === undefined)
        return false;
    if (!('firstname' in value) || value['firstname'] === undefined)
        return false;
    if (!('lastname' in value) || value['lastname'] === undefined)
        return false;
    if (!('maidenname' in value) || value['maidenname'] === undefined)
        return false;
    if (!('prefixFirstname' in value) || value['prefixFirstname'] === undefined)
        return false;
    if (!('prefixName' in value) || value['prefixName'] === undefined)
        return false;
    if (!('suffixName' in value) || value['suffixName'] === undefined)
        return false;
    if (!('externalId' in value) || value['externalId'] === undefined)
        return false;
    if (!('ssoIdentifier' in value) || value['ssoIdentifier'] === undefined)
        return false;
    if (!('previousId' in value) || value['previousId'] === undefined)
        return false;
    if (!('lastVisitedAt' in value) || value['lastVisitedAt'] === undefined)
        return false;
    if (!('signInCount' in value) || value['signInCount'] === undefined)
        return false;
    if (!('isActive' in value) || value['isActive'] === undefined)
        return false;
    if (!('gender' in value) || value['gender'] === undefined)
        return false;
    if (!('birthday' in value) || value['birthday'] === undefined)
        return false;
    if (!('birthplace' in value) || value['birthplace'] === undefined)
        return false;
    if (!('headline' in value) || value['headline'] === undefined)
        return false;
    if (!('summary' in value) || value['summary'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('confirmedAt' in value) || value['confirmedAt'] === undefined)
        return false;
    if (!('citizenshipIds' in value) || value['citizenshipIds'] === undefined)
        return false;
    if (!('citizenshipCountryCodes' in value) || value['citizenshipCountryCodes'] === undefined)
        return false;
    if (!('deceased' in value) || value['deceased'] === undefined)
        return false;
    if (!('deceasedAt' in value) || value['deceasedAt'] === undefined)
        return false;
    if (!('doNotContact' in value) || value['doNotContact'] === undefined)
        return false;
    if (!('mobilePerso' in value) || value['mobilePerso'] === undefined)
        return false;
    if (!('mobilePro' in value) || value['mobilePro'] === undefined)
        return false;
    if (!('landlinePerso' in value) || value['landlinePerso'] === undefined)
        return false;
    if (!('landlinePro' in value) || value['landlinePro'] === undefined)
        return false;
    if (!('preferredPhoneNumber' in value) || value['preferredPhoneNumber'] === undefined)
        return false;
    if (!('postalPersonal' in value) || value['postalPersonal'] === undefined)
        return false;
    if (!('postalWork' in value) || value['postalWork'] === undefined)
        return false;
    if (!('preferredPostalAddress' in value) || value['preferredPostalAddress'] === undefined)
        return false;
    if (!('config' in value) || value['config'] === undefined)
        return false;
    if (!('roleId' in value) || value['roleId'] === undefined)
        return false;
    if (!('awards' in value) || value['awards'] === undefined)
        return false;
    if (!('linkedinProfileUrl' in value) || value['linkedinProfileUrl'] === undefined)
        return false;
    if (!('website' in value) || value['website'] === undefined)
        return false;
    if (!('skype' in value) || value['skype'] === undefined)
        return false;
    if (!('bbm' in value) || value['bbm'] === undefined)
        return false;
    if (!('twitter' in value) || value['twitter'] === undefined)
        return false;
    if (!('timezone' in value) || value['timezone'] === undefined)
        return false;
    if (!('facebookProfileUrl' in value) || value['facebookProfileUrl'] === undefined)
        return false;
    if (!('instagramProfileUrl' in value) || value['instagramProfileUrl'] === undefined)
        return false;
    if (!('honoraryTitle' in value) || value['honoraryTitle'] === undefined)
        return false;
    if (!('liveLocation' in value) || value['liveLocation'] === undefined)
        return false;
    if (!('resume' in value) || value['resume'] === undefined)
        return false;
    if (!('locale' in value) || value['locale'] === undefined)
        return false;
    if (!('skills' in value) || value['skills'] === undefined)
        return false;
    if (!('customAttributes' in value) || value['customAttributes'] === undefined)
        return false;
    return true;
}
export function InternalCommonUserFromJSON(json) {
    return InternalCommonUserFromJSONTyped(json, false);
}
export function InternalCommonUserFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'name': json['name'],
        'subNetworkIds': json['sub_network_ids'],
        'extendedUpdatedAt': (new Date(json['extended_updated_at'])),
        'photo': InternalCommonUserPhotoFromJSON(json['photo']),
        'email2': json['email2'],
        'email3': json['email3'],
        'primaryEmailChoice': json['primary_email_choice'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'maidenname': json['maidenname'],
        'prefixFirstname': json['prefix_firstname'],
        'prefixName': json['prefix_name'],
        'suffixName': json['suffix_name'],
        'externalId': json['external_id'],
        'ssoIdentifier': json['sso_identifier'],
        'previousId': json['previous_id'],
        'lastVisitedAt': (json['last_visited_at'] == null ? null : new Date(json['last_visited_at'])),
        'signInCount': json['sign_in_count'],
        'isActive': json['is_active'],
        'gender': json['gender'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'birthplace': json['birthplace'],
        'headline': json['headline'],
        'summary': json['summary'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'confirmedAt': (json['confirmed_at'] == null ? null : new Date(json['confirmed_at'])),
        'citizenshipIds': json['citizenship_ids'],
        'citizenshipCountryCodes': (json['citizenship_country_codes'].map(CommonISO3166CountryCodeFromJSON)),
        'deceased': json['deceased'],
        'deceasedAt': (json['deceased_at'] == null ? null : new Date(json['deceased_at'])),
        'doNotContact': json['do_not_contact'],
        'mobilePerso': json['mobile_perso'],
        'mobilePro': json['mobile_pro'],
        'landlinePerso': json['landline_perso'],
        'landlinePro': json['landline_pro'],
        'preferredPhoneNumber': json['preferred_phone_number'],
        'postalPersonal': InternalCommonPostalAddressFromJSON(json['postal_personal']),
        'postalWork': InternalCommonPostalAddressFromJSON(json['postal_work']),
        'preferredPostalAddress': json['preferred_postal_address'],
        'config': InternalCommonUserConfigFromJSON(json['config']),
        'roleId': json['role_id'],
        'awards': json['awards'],
        'linkedinProfileUrl': json['linkedin_profile_url'],
        'website': json['website'],
        'skype': json['skype'],
        'bbm': json['bbm'],
        'twitter': json['twitter'],
        'timezone': json['timezone'],
        'facebookProfileUrl': json['facebook_profile_url'],
        'instagramProfileUrl': json['instagram_profile_url'],
        'honoraryTitle': json['honorary_title'],
        'liveLocation': InternalCommonLocationFromJSON(json['live_location']),
        'resume': InternalCommonStorageUploadFromJSON(json['resume']),
        'locale': json['locale'],
        'skills': (json['skills'].map(InternalCommonUserSkillFromJSON)),
        'customAttributes': (json['custom_attributes'].map(InternalCommonCustomAttributeFromJSON)),
    };
}
export function InternalCommonUserToJSON(json) {
    return InternalCommonUserToJSONTyped(json, false);
}
export function InternalCommonUserToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
        'name': value['name'],
        'sub_network_ids': value['subNetworkIds'],
        'extended_updated_at': ((value['extendedUpdatedAt']).toISOString()),
        'photo': InternalCommonUserPhotoToJSON(value['photo']),
        'email2': value['email2'],
        'email3': value['email3'],
        'primary_email_choice': value['primaryEmailChoice'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'maidenname': value['maidenname'],
        'prefix_firstname': value['prefixFirstname'],
        'prefix_name': value['prefixName'],
        'suffix_name': value['suffixName'],
        'external_id': value['externalId'],
        'sso_identifier': value['ssoIdentifier'],
        'previous_id': value['previousId'],
        'last_visited_at': (value['lastVisitedAt'].toISOString()),
        'sign_in_count': value['signInCount'],
        'is_active': value['isActive'],
        'gender': value['gender'],
        'birthday': (value['birthday'].toISOString()),
        'birthplace': value['birthplace'],
        'headline': value['headline'],
        'summary': value['summary'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
        'confirmed_at': (value['confirmedAt'].toISOString()),
        'citizenship_ids': value['citizenshipIds'],
        'citizenship_country_codes': (value['citizenshipCountryCodes'].map(CommonISO3166CountryCodeToJSON)),
        'deceased': value['deceased'],
        'deceased_at': (value['deceasedAt'].toISOString()),
        'do_not_contact': value['doNotContact'],
        'mobile_perso': value['mobilePerso'],
        'mobile_pro': value['mobilePro'],
        'landline_perso': value['landlinePerso'],
        'landline_pro': value['landlinePro'],
        'preferred_phone_number': value['preferredPhoneNumber'],
        'postal_personal': InternalCommonPostalAddressToJSON(value['postalPersonal']),
        'postal_work': InternalCommonPostalAddressToJSON(value['postalWork']),
        'preferred_postal_address': value['preferredPostalAddress'],
        'config': InternalCommonUserConfigToJSON(value['config']),
        'role_id': value['roleId'],
        'awards': value['awards'],
        'linkedin_profile_url': value['linkedinProfileUrl'],
        'website': value['website'],
        'skype': value['skype'],
        'bbm': value['bbm'],
        'twitter': value['twitter'],
        'timezone': value['timezone'],
        'facebook_profile_url': value['facebookProfileUrl'],
        'instagram_profile_url': value['instagramProfileUrl'],
        'honorary_title': value['honoraryTitle'],
        'live_location': InternalCommonLocationToJSON(value['liveLocation']),
        'resume': InternalCommonStorageUploadToJSON(value['resume']),
        'locale': value['locale'],
        'skills': (value['skills'].map(InternalCommonUserSkillToJSON)),
        'custom_attributes': (value['customAttributes'].map(InternalCommonCustomAttributeToJSON)),
    };
}
